<template>
    <div>
        <modal class="biz-new-bill" :display="modalStatus.bizNewBill" @modalStatus="closeModal" >
            <alarm-msg-white type="ERROR" :msg="alarm.error.msg" :count="alarm.error.count" :showAlarm="alarm.error.status" @timeOut="alarm.error.status=false"></alarm-msg-white>
            <h1>新增帳單</h1>
            <div class="biz-new-bill-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            收費方式
                        </div>
                        <span v-show="error.newBill.billType" class="error-with-title">{{error.newBill.billType}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select refName="billType" :class="{error: error.newBill.billType}" selectMsg="選擇收費方式" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li data-id="PERIOD">系統預設計費期間</li>
                                <li data-id="DAY">自訂收費日 </li>
                            </ul>
                        </rent-select>
                    </div>
                    <div class="input-note" @mouseenter="tipStatus.payway=true" @mouseleave="tipStatus.payway=false">這是什麼？</div>
                    <title-tips v-if="tipStatus.payway" class="tips-intro" title="收費方式說明" width="384px">
                        <div class="content" style="line-height: 1.57" slot="content">
                            <div style="margin-bottom: 12px;">
                                <span style="color:#3942b5">1.系統預設計費期間：</span>系統會依照合約，自動產生計費期間選單，若滿足您的需求可以使用此模式，更便捷的幫助您收租。
                            </div>
                            <div>
                                <span style="color:#3942b5">2.自訂收費日：</span>若系統預設計費期間不符合您的需求，您可以使用此模式，自訂『收費日』和『自訂計費期間』，更彈性的向租客收費，例如合約設定每月1號繳租，房客在2/15號入住。您可以使用此模式，建立收費日：2/15，計費期間：2/15 ~ 2/28的帳單。
                            </div>
                        </div>
                    </title-tips>
                </div>
                <div v-if="newBill.billType === 'DAY'" class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            自訂收費日
                        </div>
                        <span v-show="error.newBill.billDueTime" class="error-with-title">{{error.newBill.billDueTime}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="newBill.billDueTime"  :class="{'active': newBill.billDueTime, 'error': error.newBill.billDueTime}" :disabled-date="notBeforeToday"  placeholder="請選擇自訂收費日" format="YYYY-MM-DD" valueType="format"></date-picker>
                    </div>
                </div>
                <div v-if="newBill.billType === 'DAY'" class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                            自訂計費期間
                        </div>
                        <span v-show="error.newBill.periodDate" class="error-with-title">{{error.newBill.periodDate}}</span>
                    </label>
                    <div class="input-arear">
                        <date-picker v-model="newBill.periodDate" :class="{'active': newBill.periodDate.length, 'error': error.newBill.periodDate}" placeholder="請選擇自訂計費期間" format="YYYY-MM-DD" range valueType="format"></date-picker>
                    </div>
                </div>
                <div v-if="newBill.billType === 'PERIOD'" class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            系統預設計費期間：
                        </div>
                        <span v-show="error.newBill.billPeriodSeq" class="error-with-title">{{error.newBill.billPeriodSeq}}</span>
                    </label>
                    <div class="input-arear">
                        <rent-select refName="period" class="select-scroll biz-h180" :class="{error: error.newBill.billPeriodSeq}" :selectMsg="seletcMsg.period" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                            <ul>
                                <li :data-id="period.billPeriodSeq"  v-for="(period,index) in periodsList" :key="index">
                                    <div class="is-created" v-if="period.created">{{getFormatDate(period.periodStartDate)}}~{{getFormatDate(period.periodEndDate)}}  ( 已建立 )</div>
                                    {{!period.created?getFormatDate(period.periodStartDate)+'~'+getFormatDate(period.periodEndDate):''}}
                                </li>
                            </ul>
                        </rent-select>
                    </div>
                </div>
                <div class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill">*</span>
                            帳單名稱
                        </div>
                        <span v-show="error.newBill.billName" class="error-with-title">{{error.newBill.billName}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.newBill.billName}" type="text" v-model="newBill.billName" placeholder="例如：第二期 5 月份 ">
                    </div>
                </div>
                <div class="new-bill-input-group">
                    <label class="button-font input-label">
                        <div class="title">
                            <span class="must-fill"></span>
                            租金
                        </div>
                        <span v-show="error.newBill.rent" class="error-with-title">{{error.newBill.rent}}</span>
                    </label>
                    <div class="input-arear">
                        <input :class="{error: error.newBill.rent}" type="text" v-model="newBill.rent" placeholder="例如：6000" >
                    </div>
                </div>
                <div class="biz-new-bill-group">
                    <div class="left">
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    水費
                                </div>
                                <span v-show="error.newBill.waterBill" class="error-with-title">{{error.newBill.waterBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.waterBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    瓦斯費
                                </div>
                                <span v-show="error.newBill.gasBill" class="error-with-title">{{error.newBill.gasBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.gasBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    有線電視
                                </div>
                                <span v-show="error.newBill.tvBill" class="error-with-title">{{error.newBill.tvBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.tvBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    停車費
                                </div>
                                <span v-show="error.newBill.parkingBill" class="error-with-title">{{error.newBill.parkingBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.parkingBill" placeholder="例如：6000">
                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    電費
                                </div>
                                <span v-show="error.newBill.electricityBill" class="error-with-title">{{error.newBill.electricityBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.electricityBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    網路費
                                </div>
                                <span v-show="error.newBill.internetBill" class="error-with-title">{{error.newBill.internetBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.internetBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    清潔費
                                </div>
                                <span v-show="error.newBill.cleaningBill" class="error-with-title">{{error.newBill.cleaningBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.cleaningBill" placeholder="例如：6000">
                            </div>
                        </div>
                        <div class="new-bill-input-group">
                            <label class="button-font input-label">
                                <div class="title">
                                    <span class="must-fill"></span>
                                    管理費
                                </div>
                                <span v-show="error.newBill.managementBill" class="error-with-title">{{error.newBill.managementBill}}</span>
                            </label>
                            <div class="input-arear">
                                <input type="text" v-model="newBill.managementBill" placeholder="例如：6000">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="checkInput()">新增</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import alarmMsgWhite from '@/components/bussiness/widges/alarms/alarmMsgWhite.vue';
import titleTips from '@/components/bussiness/widges/tips/titleTips.vue';
import { mapGetters } from 'vuex'

import { 
    createBill,
    getBillPeriods
} from "@/apis/company/bill.js"; 
const today = new Date();
today.setHours(0, 0, 0, 0);

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            periodsList: [],
            newBill: {
                // contractCid: this.cid,
                billType: null,
                billPeriodSeq: null,
                billDueTime: null,
                periodDate: [],
                billName: '',
                rent: null,
                waterBill: null,
                gasBill: null,
                tvBill: null,
                parkingBill: null,
                electricityBill: null,
                internetBill: null,
                cleaningBill: null,
                managementBill: null
            },
            error: {
                newBill:{
                    billDueTime: '',
                    billType: '',
                    billPeriodSeq: '',
                    billName: '',
                    rent: '',
                    gasBill: '',
                    tvBill: '',
                    waterBill: '',
                    parkingBill: '',
                    electricityBill: '',
                    internetBill: '',
                    cleaningBill: '',
                    managementBill: ''
                }
            },
            isDefault: false,
            seletcMsg: {
                house: '請選擇房源',
                period: '選擇系統預設計費期間'
            },
            alarm: {
                success:{
                    status: false,
                    msg: null,
                    count: 2000
                },
                error:{
                    status: false,
                    msg: null,
                    count: 2000
                }
            },
            tipStatus: {
                payway: false,
            },
        }
    },
    props:{
        cid: null
    },
    mounted (){
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        newBill: {
            handler: function (val) {
                if(val.billType){
                    this.error.newBill.billType = ''
                }
                if(val.billDueTime){
                    this.error.newBill.billDueTime = ''
                }
                if(val.billName){
                    this.error.newBill.billName = ''
                }
                if(val.billPeriodSeq){
                    this.error.newBill.billPeriodSeq = ''
                }
                if(val.rent){
                    if(this.checkIsNum(val.rent)){
                        this.error.newBill.rent = ''
                    }else{
                        this.error.newBill.rent = '請填寫數字'
                    }
                }
                if(val.gasBill) {
                    if(this.checkIsNum(val.gasBill)){
                        this.error.newBill.gasBill = ''
                    }else{
                        this.error.newBill.gasBill = '請填寫數字'
                    }
                }
                if(val.tvBill) {
                    if(this.checkIsNum(val.tvBill)){
                        this.error.newBill.tvBill = ''
                    }else{
                        this.error.newBill.tvBill = '請填寫數字'
                    }
                }
                if(val.waterBill) {
                    if(this.checkIsNum(val.waterBill)){
                        this.error.newBill.waterBill = ''
                    }else{
                        this.error.newBill.waterBill = '請填寫數字'
                    }
                }
                if(val.parkinBill) {
                    if(this.checkIsNum(val.parkingBill)){
                        this.error.newBill.parkingBill = ''
                    }else{
                        this.error.newBill.parkingBill = '請填寫數字'
                    }
                }
                if(val.electricityBill) {
                    if(this.checkIsNum(val.electricityBill)){
                        this.error.newBill.electricityBill = ''
                    }else{
                        this.error.newBill.electricityBill = '請填寫數字'
                    }
                }
                if(val.interneBill) {
                    if(this.checkIsNum(val.internetBill)){
                        this.error.newBill.internetBill = ''
                    }else{
                        this.error.newBill.internetBill = '請填寫數字'
                    }
                }
                if(val.cleaningBill) {
                    if(this.checkIsNum(val.cleaningBill)){
                        this.error.newBill.cleaningBill = ''
                    }else{
                        this.error.newBill.cleaningBill = '請填寫數字'
                    }
                }
                if(val.managementBill) {
                    if(this.checkIsNum(val.managementBill)){
                        this.error.newBill.managementBill = ''
                    }else{
                        this.error.newBill.managementBill = '請填寫數字'
                    }
                }
            },
            deep: true
        },
        cid: {
            handler: function (val) {
                this.getBillPeriods(val)
                this.isDefault = false
            },
            immediate: true
        },
        periodsList: function (val) {
            if(val.length == 0){
                this.error.newBill.billPeriodSeq = '無可用帳單'
            }else{
                this.error.newBill.billPeriodSeq = ''
            }
        },
        // 'modalStatus.newBill': function (val) {
        //     if(val){
        //         this.$analytics.logEvent('新增費用', { screen_name: '新增費用'})
        //     }
        // }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        getSelectId: function (value) {
            this.newBill.billPeriodSeq = value.id
        },
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'billType' ){
                this.newBill.billType = value.id
            }else if ( value.ref == 'period' ){
                this.newBill.billPeriodSeq = value.id
            }
        },
        addNewBill: function () {
            this.$analyticsBiz.logEvent('送出新增費用', { screen_name: '送出新增費用'})
            
            let data = {
                billType: this.newBill.billType,
                billDueTime: this.newBill.billDueTime?this.newBill.billDueTime:null,
                periodStartDate: this.newBill.periodDate[0]?this.newBill.periodDate[0]:null,
                periodEndDate: this.newBill.periodDate[1]?this.newBill.periodDate[1]:null,
                contractCid: this.cid,
                billPeriodSeq: this.newBill.billPeriodSeq?this.newBill.billPeriodSeq:null,
                billName: this.newBill.billName,
                rent: this.newBill.rent?this.newBill.rent:0,
                waterBill: this.newBill.waterBill?this.newBill.waterBill:0,
                gasBill: this.newBill.gasBill?this.newBill.gasBill:0,
                tvBill: this.newBill.tvBill?this.newBill.tvBill:0,
                parkingBill: this.newBill.parkingBill?this.newBill.parkingBill:0,
                electricityBill: this.newBill.electricityBill?this.newBill.electricityBill:0,
                internetBill: this.newBill.internetBill?this.newBill.internetBill:0,
                cleaningBill: this.newBill.cleaningBill?this.newBill.cleaningBill:0,
                managementBill: this.newBill.managementBill?this.newBill.managementBill:0
            }
            console.log(data)
            createBill(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.getBillPeriods(this.cid)
                    this.$emit('saveBillStatus', true);
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '已通知房客繳交租金',description: '<a href="/enterprise/financialReport/billMgt">帳單紀錄 <img src="../../../static/img/black-arrow-down.svg" /></a>',type: 'success',closeBtn: true})
                    this.closeModal()
                }else{
                    this.alarm.error.msg = res.data.errorMsg
                    this.alarm.error.status = true
                }
            })
            .catch(err => {
                // reject(err)
            })
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizNewBill'})
            this.periodDate = []
            this.newBill = {
                billType: null,
                billPeriodSeq: null,
                billDueTime: null,
                periodDate: [],
                billName: null,
                rent: null,
                waterBill: null,
                gasBill: null,
                tvBill: null,
                parkingBill: null,
                electricityBill: null,
                internetBill: null,
                cleaningBill: null,
                managementBill: null
            }
            this.error.newBill = {
                billType: null,
                billPeriodSeq: null,
                billDueTime: null,
                periodStartDate: null,
                periodEndDate: null,
                billName: null,
                rent: null,
                gasBill: null,
                tvBill: null,
                waterBill: null,
                parkingBill: null,
                electricityBill: null,
                internetBill: null,
                cleaningBill: null,
                managementBill: null
            }
            this.componentKey += 1
            this.isDefault = true
        },
        getBillPeriods: function (cid) {
            if(cid){
                let params = {
                    contractCid: cid
                }

                getBillPeriods(params)
                .then(res => {
                    console.log(res)
                    if( res.data.status == "SUCCESS" ){
                        this.periodsList = res.data.result
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
            
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        checkInput: function () {
            if(!this.newBill.billType){
                this.error.newBill.billType = '請選擇收費方式'
            }else{
                this.error.newBill.billType = ''
            }
            if(this.newBill.billType === 'DAY' && !this.newBill.billDueTime){
                this.error.newBill.billDueTime = '請選擇收費日'
            }else{
                this.error.newBill.billDueTime = ''
            }
            if(!this.newBill.billName){
                this.error.newBill.billName = '請填寫帳單名稱'
            }else{
                this.error.newBill.billName = ''
            }

            // if(!this.newBill.rent){
            //     this.error.newBill.rent = '請填寫金額'
            // }else{
            //     this.error.newBill.rent = ''
            // }

            if(this.newBill.billType === 'PERIOD' && !this.newBill.billPeriodSeq){
                this.error.newBill.billPeriodSeq = '請選擇收費區間'
            }else{
                this.error.newBill.billPeriodSeq = ''
            }
            if( !this.newBill.rent &&
                !this.newBill.gasBill &&
                !this.newBill.tvBill &&
                !this.newBill.waterBill &&
                !this.newBill.parkingBill &&
                !this.newBill.electricityBill &&
                !this.newBill.internetBill &&
                !this.newBill.cleaningBill &&
                !this.newBill.managementBill){
                    // console.log(this.newBill.rent)
                    // console.log(this.newBill.gasBill)
                    // console.log(this.newBill.tvBill)
                    // console.log(this.newBill.waterBill)
                    // console.log(this.newBill.parkingBill)
                    // console.log(this.newBill.electricityBill)
                    // console.log(this.newBill.internetBill)
                    // console.log(this.newBill.cleaningBill)
                    // console.log(this.newBill.managementBill)
                    this.alarm.error.msg = '至少輸入一筆金額'
                    this.alarm.error.status = true
            }else{
                this.alarm.error.msg = null
                this.alarm.error.status = false
            }
            if(
                this.newBill.billName &&
                this.newBill.billType &&
                !this.error.newBill.billType &&
                !this.error.newBill.billDueTime &&
                !this.error.newBill.periodDate &&
                !this.error.newBill.billName &&
                !this.error.newBill.billPeriodSeq &&
                !this.error.newBill.rent 
            ){
                this.addNewBill()
            }
        },
        notBeforeToday(date) {
            return date < today;
        },
    },
    computed: {
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSelect,
        DatePicker,
        alarmMsgWhite,
        titleTips
    }
}
</script>
<style lang="scss">
    #modal.biz-new-bill{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .alarm-msg{
                    top: 10px;
                }
                .biz-new-bill-wrap{
                    padding: 0 32px 0 32px;
                    height: 415px;
                    overflow-x: hidden;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .tips-intro{
                        
                    }
                    .new-bill-input-group{
                        margin-bottom: 30px;
                    }
                    .biz-new-bill-group{
                        display: flex;
                        .left{
                            margin-right: 28px;
                        }
                    }
                    .mx-datepicker{
                        width: 384px;
                        input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                            margin-bottom: 0px;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 14px;
                        }
                    }
                    .mx-datepicker.error{
                        input{
                            border: solid 1px #fc7171 !important;
                        }
                    }
                    .mx-datepicker:hover{
                        input{
                            border: 1px solid #292625;
                            color: #292625;
                        }
                        i{
                            color: #292625;
                        }
                    }
                    .mx-datepicker.active{
                        input{
                            color: #292625;
                            &::placeholder {
                                color: #292625;
                            }
                            &:-ms-input-placeholder {
                                color: #292625;
                            }
                            
                            &::-ms-input-placeholder {
                                color: #292625;
                            }
                        }
                        i{
                            color: #292625;
                        }
                    }
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/newBill.vue